import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ChatClient } from '../../domain/models/chat-client.model';
import { IChatClientsRepository } from '../../domain/repositories/chat-clients.repository';
import { ChatClientsRemoteDatasource } from '../datasources/remote/chat-clients.remote-datasource';
import { ChatClientMapper } from '../mappers/chat-client.mapper';


@Injectable()
export class ChatClientsRepositoryImpl implements IChatClientsRepository {
  private readonly datasource = inject(ChatClientsRemoteDatasource);
  private readonly mapper = inject(ChatClientMapper);

  public list(organizationId: number): Observable<readonly ChatClient[]> {
    return this.datasource.listPetOwners(organizationId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toChatClient(dto))),
    );
  }
}
